import { render, staticRenderFns } from "./NavigationLinks.vue?vue&type=template&id=5d954768"
import script from "./NavigationLinks.vue?vue&type=script&lang=js"
export * from "./NavigationLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports